import { string } from 'yup'

export const createSsidNameSchema = (t: (key: string) => string) =>
  string()
    .required(t('ui_elements.required_field'))
    .matches(/^[a-zA-Z0-9 _-]{3,}$/, t('event_ssids.errors.name_invalid'))
    .max(32, t('event_ssids.errors.name_max_length'))
